export default (siteName) => [
    {
        path: 'revenue-goal',
        name: 'revenue-goal',
        component: () => import('../../components/dashboard/Finance/RevenueGoal/index.vue'),
        meta: {
            title: `營收目標設定${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'revenue-goal/add',
        name: 'revenue-goal-add',
        component: () => import('../../components/dashboard/Finance/RevenueGoal/EditDialog.vue'),
        meta: {
            title: `新增營收目標設定${siteName}`,
            activeMenu: 'settings',
        },
    },

    {
        path: 'revenue-goal/edit/:year',
        name: 'revenue-goal-edit',
        component: () => import('../../components/dashboard/Finance/RevenueGoal/EditDialog.vue'),
        meta: {
            title: `編輯營收目標設定${siteName}`,
            activeMenu: 'settings',
        },
    },
];
